let internalIsMock: boolean = false;
// const mockReg = /127.0.0.1|localhost|dev.sankuai.com/gi;

/**
 * 是否开启 mock
 * @returns {boolean} 是否开启 mock
 */
export function isMock(): boolean {
  return internalIsMock;
}

/**
 * 设置是否开启 mock
 * @param {boolean} isMock 是否开启 mock
 */
export function setIsMock(mock: boolean): void {
  // if (process.env.NODE_ENV !== 'production') {
  //   internalIsMock = isMock;
  // }
  internalIsMock = mock;
}

/**
 * 参数隧道数据
 * https://km.sankuai.com/page/195064302
 */
export function getParamsTunnelData(): any {
  return {
    "serialCode": "564cdd91-3ff1-4de1-8306-2f79106db12d",
    "oneclickpay_dispatcher": {
        "halfScreenWindow": {
            "adjustPayList": {
                "adjustInfo": "\u4F18\u5148\u6263\u6B3E\u65B9\u5F0F",
                "userPayList": [
                    {
                        "description": "\u6392\u5E8F\u7B2C\u4E00\u4F4D\u7684\u652F\u4ED8\u65B9\u5F0F\u4E3A\u4F18\u5148\u6263\u6B3E\u65B9\u5F0F\uFF0C\u82E5\u6263\u6B3E\u5931\u8D25\u5C06\u6309\u987A\u5E8F\u5B8C\u6210\u6263\u6B3E",
                        "initAdjust": false,
                        "marketPriority": 2,
                        "payModeList": [
                            {
                                "bizId": "5062685699",
                                "payMode": 2,
                                "payModeText": "\u4E2D\u56FD\u5DE5\u5546\u94F6\u884C\u50A8\u84C4\u5361 (7394)",
                                "payTypeUniqueKey": "quickbank_36_5062685699",
                                "promoLabel": "\u672C\u5355\u53EF\u51CF12\u5143"
                            },
                            {
                                "bizId": "0",
                                "payMode": 1,
                                "payModeText": "\u4F59\u989D",
                                "payTypeUniqueKey": "balancepay",
                                "promoLabel": "\u672C\u5355\u53EF\u51CF3\u5143"
                            },
                            {
                                "bizId": "5062684331",
                                "payMode": 2,
                                "payModeText": "\u4E2D\u56FD\u94F6\u884C\u50A8\u84C4\u5361 (7600)",
                                "payTypeUniqueKey": "quickbank_39_5062684331",
                                "promoLabel": "\u672C\u5355\u53EF\u51CF12\u5143"
                            },
                            {
                                "bizId": "5062684486",
                                "payMode": 2,
                                "payModeText": "\u5E73\u5B89\u94F6\u884C\u50A8\u84C4\u5361 (6230)",
                                "payTypeUniqueKey": "quickbank_43_5062684486",
                                "promoLabel": "\u672C\u5355\u53EF\u51CF12\u5143"
                            },
                            {
                                "bizId": "0",
                                "payMode": 7,
                                "payModeText": "\u7F8E\u56E2\u6708\u4ED8",
                                "payTypeUniqueKey": "creditpay",
                                "promoLabel": "\u672C\u5355\u53EF\u51CF3\u5143"
                            }
                        ],
                        "payType": 2,
                        "secondTitle": "\u957F\u6309\u53F3\u4FA7\u56FE\u6807\u53EF\u62D6\u52A8\u8C03\u6574\u6263\u6B3E\u987A\u5E8F"
                    }
                ]
            },
            "agreementList": [
                {
                    "agreementLink": "https://mpay.meituan.com/resource/ptp/pages/qdb-nopasswordpay-agreement-20190808.html",
                    "agreementName": "\u300A\u5C0F\u989D\u514D\u5BC6\u670D\u52A1\u534F\u8BAE\u300B"
                },
                {
                    "agreementLink": "https://mpay.meituan.com/resource/ptp/pages/qdb-faceid-agreement.html",
                    "agreementName": "\u300A\u9762\u5BB9 ID \u670D\u52A1\u534F\u8BAE\u300B"
                }
            ],
            "button": {
                "downBtn": {
                    "buttonPath": {
                        "stdCashierUrl": "cashier/dispatcher"
                    },
                    "buttonText": "\u6682\u4E0D\u5F00\u542F\uFF0C\u7EE7\u7EED\u652F\u4ED8"
                },
                "upBtn": {
                    "buttonPath": {
                        "mpmUrl": "/api/wallet/oneclickpay/openoneclickpay",
                        "payUrl": "cashier/oneclickpay"
                    },
                    "buttonText": "\u786E\u8BA4\u5347\u7EA7\u5E76\u652F\u4ED8",
                    "promoContent": ""
                }
            },
            "guideRuleName": "",
            "halfScreenType": 4,
            "oneClickPayOpenStatus": 1,
            "payTypeGuideStyleName": "oldStyle",
            "promoShowInfo": {
                "payModeText": "\u4E2D\u56FD\u5DE5\u5546\u94F6\u884C\u50A8\u84C4\u5361 (7394)",
                "reduce": "12"
            },
            "style": "openGuideV3Style",
            "titleModel": {
                "mainTitle": "\u5347\u7EA7\u7F8E\u56E2\u6781\u901F\u652F\u4ED8",
                "subDetails": [
                    "\u8D26\u6237\u5B89\u5168\u4FDD\u969C\u4E2D",
                    "500\u5143\u4EE5\u5185\u6309\u6263\u6B3E\u987A\u5E8F\u4E00\u952E\u5B8C\u6210\u652F\u4ED8"
                ],
                "titleDescPic": "https://p1.meituan.net/travelcube/99e70018d0dc2d663376f6f02d4c70fa5208.png"
            }
        },
        "extendInfo": {
            "mtPlanId": 1585,
            "sellerId": "11000000003985",
            "oneclickpayModalUrl": "/resource/pay-deduction-part/oneclickpay-modal/0.3.0/index.html"
        },
        "routeStatus": 0,
        "cashierSessionId": "11100300000009915000000",
        "scene": "openOneClickPayAdjustPayList"
    },
    "tradeno": "25061010100001670004461391570930",
    "pay_token": "b3dd392e5680e27ec547cf8096a99c2c",
    "merchant_no": "",
    "pay_success_url": "",
    "redr_url": "",
    "ext_param": "{\"open_oneclickpay\":\"1\",\"serialCode\":\"564cdd91-3ff1-4de1-8306-2f79106db12d\"}",
    "extra_data": "{\"open_oneclickpay\":\"1\",\"serialCode\":\"564cdd91-3ff1-4de1-8306-2f79106db12d\"}",
    "app_name": "group",
    "app_version": "12.29.200",
    "device_platform": "harmony",
    "user_city_id": 0,
    "user_location": "",
    "device_id": "0000000000000993683D7580E4A2F87C48151F5ADAAF8A174776974599960189",
    "device_uuid": "0000000000000993683D7580E4A2F87C48151F5ADAAF8A174776974599960189",
    "app_pay_sdk_version": "13.1.1",
    "device_system_version": "OpenHarmony-5.0.5.165",
    "device_manufacturer": "HUAWEI",
    "device_model": "HUAWEI Mate 60 Pro",
    "user_id": "5168050930",
    "user_token": "AgHLIJLadfBHq-U-EbvJtuKjxG_UElzfYvdKqBOPV3fs7YIxWHxRKDfJqv-CDi-tR8B9JJpMy88mXQAAAADOGQsAVq77t0yUVn-WuGx5CySyi2Vqcu7OKejXAVsYOvhpFhoNudIM04_Huz6BgTqEXWMr",
    "device_install_apps": 3,
    "member_id": "21000219887869",
    "zone_user_id": "5168050930",
    "is_debug": 1,
    "cashier_host": "https://stable.pay.test.sankuai.com",
    "env": "test",
    "stat_time": "1749542151812",
    "network_type": "wifi",
    "half_page_render_data": {
      "initialData": {
        "adjustPayList": {
          "adjustInfo": "优先扣款方式",
          "userPayList": [
            {
              "description": "排序第一位的支付方式为优先扣款方式，若扣款失败将按顺序完成扣款",
              "initAdjust": false,
              "marketPriority": 2,
              "payModeList": [
                {
                  "bizId": "0",
                  "payMode": 7,
                  "payModeText": "美团月付",
                  "payTypeUniqueKey": "creditpay",
                  "preExposureLabel": {
                    "details": [
                      {
                        "discount": 599,
                        "promo_id": "101492",
                        "promo_type": "SUBSIDY",
                        "real_discount": 599
                      }
                    ],
                    "discount": 599
                  }
                },
                {
                  "bizId": "0",
                  "payMode": 1,
                  "payModeText": "余额",
                  "payTypeUniqueKey": "balancepay"
                },
                {
                  "bizId": "5062800383",
                  "payMode": 2,
                  "payModeText": "中国建设银行储蓄卡 (7064)",
                  "payTypeUniqueKey": "quickbank_35_5062800383",
                  "promoLabel": "开通返0.3元"
                }
              ],
              "payType": 2,
              "secondTitle": "长按右侧图标可拖动调整扣款顺序"
            },
          ]
        }
      }
    }
};
}